"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
/**
 * Set an attendee network health
 */
function setAttendeeReceivedFrame(attendeeId, frame) {
  return (0, _actionUtils.actionCreator)(_types.BROADCAST_SET_ATTENDEE_RECEIVED_FRAME, {
    attendeeId: attendeeId,
    frame: frame
  });
}
var _default = exports["default"] = setAttendeeReceivedFrame;